"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const material_1 = require("@mui/material");
const ui_1 = require("@jbrowse/core/ui");
const mui_1 = require("tss-react/mui");
const mobx_react_1 = require("mobx-react");
const useStyles = (0, mui_1.makeStyles)()(theme => ({
    formElt: {
        margin: theme.spacing(3),
        width: 400,
    },
    dialogContent: {
        width: '80em',
    },
    root: {
        padding: 4,
    },
}));
function TextField2(props) {
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(material_1.TextField, { ...props })));
}
function FormControl2({ children }) {
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(material_1.FormControl, null, children)));
}
const SequenceFeatureSettingsDialog = (0, mobx_react_1.observer)(function ({ handleClose, model, }) {
    const { classes } = useStyles();
    const { upperCaseCDS } = model;
    const [intronBp, setIntronBp] = (0, react_1.useState)(`${model.intronBp}`);
    const [upDownBp, setUpDownBp] = (0, react_1.useState)(`${model.upDownBp}`);
    const intronBpValid = !Number.isNaN(+intronBp);
    const upDownBpValid = !Number.isNaN(+upDownBp);
    return (react_1.default.createElement(ui_1.Dialog, { maxWidth: "xl", open: true, onClose: () => handleClose(), title: "Feature sequence settings" },
        react_1.default.createElement(material_1.DialogContent, { className: classes.dialogContent },
            react_1.default.createElement(TextField2, { label: "Number of intronic bases around splice site to display", className: classes.formElt, value: intronBp, helperText: !intronBpValid ? 'Not a number' : '', error: !intronBpValid, onChange: event => setIntronBp(event.target.value) }),
            react_1.default.createElement(TextField2, { label: "Number of bases up/down stream of feature to display", className: classes.formElt, value: upDownBp, helperText: !upDownBpValid ? 'Not a number' : '', error: !upDownBpValid, onChange: event => setUpDownBp(event.target.value) }),
            react_1.default.createElement(FormControl2, null,
                react_1.default.createElement(material_1.FormLabel, null, "Sequence capitalization"),
                react_1.default.createElement(material_1.RadioGroup, { value: upperCaseCDS ? 'cds' : 'unchanged', onChange: e => model.setUpperCaseCDS(e.target.value === 'cds') },
                    react_1.default.createElement(material_1.FormControlLabel, { value: "cds", control: react_1.default.createElement(material_1.Radio, { className: classes.root, size: "small" }), label: "Capitalize CDS and lower case everything else" }),
                    react_1.default.createElement(material_1.FormControlLabel, { value: "unchanged", control: react_1.default.createElement(material_1.Radio, { className: classes.root, size: "small" }), label: "Capitalization from reference genome sequence" })))),
        react_1.default.createElement(material_1.DialogActions, null,
            react_1.default.createElement(material_1.Button, { onClick: () => {
                    model.setIntronBp(+intronBp);
                    model.setUpDownBp(+upDownBp);
                    handleClose();
                }, disabled: !intronBpValid || !upDownBpValid, color: "primary", variant: "contained" }, "Submit"),
            react_1.default.createElement(material_1.Button, { onClick: () => handleClose(), color: "secondary", autoFocus: true, variant: "contained" }, "Cancel"))));
});
exports.default = SequenceFeatureSettingsDialog;
